(() => {
  const configElement = document.getElementById('bm-newsletter-locale-data');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  // Liquid translations may HTML-escape apostrophes before JSON encoding.
  const decode = text => text.replace(/&(#39|apos|quot|amp|lt|gt);/g, (_, entity) => ({'#39':"'",apos:"'",quot:'"',amp:'&',lt:'<',gt:'>'})[entity]);
  config.text = config.text.map(row => ({from:row.from,to:decode(row.to)}));
  config.termsLabel = decode(config.termsLabel);
  const normalize = text => text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  const translations = new Map(config.text.map(row => [normalize(row.from), row.to]));
  const forms = '[data-testid="klaviyo-form-SJnkxq"],[data-testid="klaviyo-form-WfLxww"],[data-testid="klaviyo-form-UFUqU7"],[data-testid="klaviyo-form-S9dYeJ"],[data-testid="klaviyo-form-SNxvZz"]';
  function translateNode(node) {
    const translated = translations.get(normalize(node.data));
    if (translated && normalize(node.data) !== normalize(translated)) {
      const leading = node.data.match(/^\s*/)[0];
      const trailing = node.data.match(/\s*$/)[0];
      node.data = leading + translated + trailing;
    }
  }
  // Include an affected element itself as well as its descendants.
  function select(root, selector, includeRoot = true) {
    const elements = Array.from(root.querySelectorAll(selector));
    if (includeRoot && root.nodeType === Node.ELEMENT_NODE && root.matches(selector)) elements.unshift(root);
    return elements;
  }
  function localize(root, includeRoot = false) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      translateNode(node);
      if (normalize(node.data) === '.' && normalize(node.parentElement?.previousElementSibling?.textContent || '').endsWith('.')) node.data = '';
    }
    select(root, '[placeholder],[aria-label],img[alt]', includeRoot).forEach(element => {
      for (const attribute of ['placeholder','aria-label','alt']) {
        const current = element.getAttribute(attribute);
        const translated = current && translations.get(normalize(current));
        if (translated && current !== translated) element.setAttribute(attribute, translated);
      }
    });
    select(root, 'a[href]', includeRoot).forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin === location.origin) {
        const path = url.pathname.replace(/^\/(de|en|es|fr|it|nl)(?=\/pages\/)/, '');
        if (/^\/pages\/(datenschutzerklarung|impressum|agb)$/.test(path)) {
          const target = normalize(link.textContent) === normalize(config.termsLabel) ? '/pages/agb' : path;
          url.pathname = (config.locale === 'de' ? '' : '/' + config.locale) + target;
          if (link.href !== url.href) link.href = url.href;
        }
      }
    });

  }
  const titles = new Map((config.productTitles || []).map(row => [normalize(row.from).toLowerCase(), row.to]));
  function localizeRecentlyViewed(root = document) {
    select(root, '[id^="RecentlyViewed-"] .grid-product__title').forEach(element => {
      const translated = titles.get(normalize(element.textContent).toLowerCase());
      if (!translated) return;
      if (element.textContent !== translated) element.textContent = translated;
      const link = element.closest('a[href]');
      if (link) {
        const url = new URL(link.href, location.origin);
        if (url.origin === location.origin) {
          url.pathname = '/' + config.locale + url.pathname.replace(/^\/(de|en|es|fr|it|nl)(?=\/products\/)/, '');
          if (link.href !== url.href) link.href = url.href;
        }
      }
    });
  }

  // Scope these presentation labels to existing navigation, product galleries and Judge.me.
  // Review content, helpful votes, review scores and form rules are not modified.
  const interfaceDictionary = {"de":{"primary":"Hauptnavigation","breadcrumbs":"Navigationspfad","reviews":"Kundenbewertungen","reviewsSite":"Bewertungen auf der Bewertungsseite ansehen","helpful":"Als hilfreich markieren","notHelpful":"Als nicht hilfreich markieren","filters":"Filter","gallery":"Galerieelement","starOne":"Stern","starMany":"Sterne","reviewOne":"Bewertung","reviewMany":"Bewertungen","rating":"{value} von {max} {stars}","flag":"Flagge: {country}","reviewFormClose":"Bewertungsformular schließen","reviewFormPages":"Seiten des Bewertungsformulars","reviewFormNav":"Navigation im Bewertungsformular","previousStep":"Vorheriger Schritt","nextStep":"Nächster Schritt","ratingField":"Bewertung"},"en":{"primary":"Primary navigation","breadcrumbs":"Breadcrumbs","reviews":"Customer reviews","reviewsSite":"View reviews on the Reviews Site","helpful":"Mark as helpful","notHelpful":"Mark as not helpful","filters":"Filters","gallery":"Gallery item","starOne":"star","starMany":"stars","reviewOne":"review","reviewMany":"reviews","rating":"{value} out of {max} {stars}","flag":"{country} flag","reviewFormClose":"Close review form","reviewFormPages":"Review form pages","reviewFormNav":"Review form navigation","previousStep":"Previous step","nextStep":"Next step","ratingField":"Rating"},"es":{"primary":"Navegación principal","breadcrumbs":"Ruta de navegación","reviews":"Reseñas de clientes","reviewsSite":"Ver reseñas en la página de reseñas","helpful":"Marcar como útil","notHelpful":"Marcar como no útil","filters":"Filtros","gallery":"Elemento de la galería","starOne":"estrella","starMany":"estrellas","reviewOne":"reseña","reviewMany":"reseñas","rating":"{value} de {max} {stars}","flag":"Bandera de {country}","reviewFormClose":"Cerrar formulario de reseña","reviewFormPages":"Páginas del formulario de reseña","reviewFormNav":"Navegación del formulario de reseña","previousStep":"Paso anterior","nextStep":"Siguiente paso","ratingField":"Valoración"},"fr":{"primary":"Navigation principale","breadcrumbs":"Fil d’Ariane","reviews":"Avis clients","reviewsSite":"Voir les avis sur le site d’avis","helpful":"Marquer comme utile","notHelpful":"Marquer comme inutile","filters":"Filtres","gallery":"Élément de la galerie","starOne":"étoile","starMany":"étoiles","reviewOne":"avis","reviewMany":"avis","rating":"{value} sur {max} {stars}","flag":"Drapeau : {country}","reviewFormClose":"Fermer le formulaire d’avis","reviewFormPages":"Pages du formulaire d’avis","reviewFormNav":"Navigation du formulaire d’avis","previousStep":"Étape précédente","nextStep":"Étape suivante","ratingField":"Note"},"it":{"primary":"Navigazione principale","breadcrumbs":"Percorso di navigazione","reviews":"Recensioni dei clienti","reviewsSite":"Vedi le recensioni sul sito delle recensioni","helpful":"Segna come utile","notHelpful":"Segna come non utile","filters":"Filtri","gallery":"Elemento della galleria","starOne":"stella","starMany":"stelle","reviewOne":"recensione","reviewMany":"recensioni","rating":"{value} su {max} {stars}","flag":"Bandiera: {country}","reviewFormClose":"Chiudi il modulo della recensione","reviewFormPages":"Pagine del modulo della recensione","reviewFormNav":"Navigazione del modulo della recensione","previousStep":"Passaggio precedente","nextStep":"Passaggio successivo","ratingField":"Valutazione"},"nl":{"primary":"Hoofdnavigatie","breadcrumbs":"Broodkruimelpad","reviews":"Klantbeoordelingen","reviewsSite":"Bekijk beoordelingen op de beoordelingssite","helpful":"Markeren als nuttig","notHelpful":"Markeren als niet nuttig","filters":"Filters","gallery":"Galerij-item","starOne":"ster","starMany":"sterren","reviewOne":"beoordeling","reviewMany":"beoordelingen","rating":"{value} van {max} {stars}","flag":"Vlag: {country}","reviewFormClose":"Beoordelingsformulier sluiten","reviewFormPages":"Pagina’s van het beoordelingsformulier","reviewFormNav":"Navigatie van het beoordelingsformulier","previousStep":"Vorige stap","nextStep":"Volgende stap","ratingField":"Beoordeling"}};
  const interfaceText = interfaceDictionary[config.locale] || interfaceDictionary.de;
  let countryNames;
  try { countryNames = new Intl.DisplayNames([config.locale], {type:'region'}); } catch (error) {}
  function localizeInterfaceLabels(root = document) {
    const d = interfaceText;
    select(root, '[role="navigation"][aria-label="Primary"],nav[aria-label="Primary"]').forEach(e => { if (e.getAttribute('aria-label') !== d.primary) e.setAttribute('aria-label', d.primary); });
    select(root, 'nav.breadcrumb[aria-label="breadcrumbs"]').forEach(e => { if (e.getAttribute('aria-label') !== d.breadcrumbs) e.setAttribute('aria-label', d.breadcrumbs); });
    select(root, '.product-section [aria-label^="Page dot "]').forEach(e => {
      const match = e.getAttribute('aria-label').match(/^Page dot (\d+)$/);
      if (match) e.setAttribute('aria-label', d.gallery + ' ' + match[1]);
    });
    const exact = {
      'Customer reviews':d.reviews, 'View reviews on the Reviews Site':d.reviewsSite,
      'Mark as helpful':d.helpful, 'Mark as not helpful':d.notHelpful, 'Filters':d.filters,
      'Close review form':d.reviewFormClose, 'Review form pages':d.reviewFormPages,
      'Review form navigation':d.reviewFormNav, 'Previous step':d.previousStep,
      'Next step':d.nextStep, 'Rating':d.ratingField
    };
    select(root, '.jdgm-widget [aria-label],#judgeme_product_reviews [aria-label],.jdgm-write-review-modal__container [aria-label]').forEach(e => {
      const label = e.getAttribute('aria-label');
      let translated = exact[label];
      const histogram = label.match(/^([\d.,]+)% \((\d+)\) reviews with (\d+) star rating$/);
      const rating = label.match(/^([\d.,]+) out of ([\d.,]+) stars?$/);
      const formStar = label.match(/^([1-5]) stars?$/);
      if (formStar) {
        translated = formStar[1] + ' ' + (Number(formStar[1]) === 1 ? d.starOne : d.starMany);
      } else if (histogram) {
        translated = histogram[1] + '% (' + histogram[2] + ' ' + (Number(histogram[2]) === 1 ? d.reviewOne : d.reviewMany) + ') · ' + histogram[3] + ' ' + (Number(histogram[3]) === 1 ? d.starOne : d.starMany);
      } else if (rating) {
        // Histogram rows represent a star category; the app emits "5 out of 1 stars".
        // Name that category directly, preserving its actual star number.
        translated = e.closest('.jm-histogram-row')
          ? rating[1] + ' ' + (Number(rating[1]) === 1 ? d.starOne : d.starMany)
          : d.rating.replace('{value}',rating[1]).replace('{max}',rating[2]).replace('{stars}',Number(rating[2]) === 1 ? d.starOne : d.starMany);
      }
      if (translated && translated !== label) e.setAttribute('aria-label', translated);
    });
    if (countryNames) select(root, '.jdgm-widget img[alt],#judgeme_product_reviews img[alt]').forEach(e => {
      const match = e.alt.match(/^([A-Z]{2}) flag$/);
      if (!match) return;
      const country = countryNames.of(match[1]);
      if (country && country !== match[1]) e.alt = d.flag.replace('{country}',country);
    });
  }

  function scan(root = document) {
    localizeRecentlyViewed(root);
    localizeInterfaceLabels(root);
    // The initial document pass preserves the existing form-root behavior.
    select(root, forms).forEach(form => localize(form, root !== document));
    // Translate the existing native Klaviyo teaser without changing its layout or handlers.
    select(root, '.kl-teaser-WfLxww [role="button"],.kl-teaser-UFUqU7 [role="button"]').forEach(button => {
      const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) translateNode(walker.currentNode);
    });
    select(root, '[role="dialog"]').forEach(dialog => {
      if (!dialog.querySelector(forms)) return;
      if (dialog.getAttribute('aria-label') === 'POPUP Form') dialog.setAttribute('aria-label', config.formLabel);
      const close = dialog.querySelector('button[aria-label="Close dialog"],button[aria-label="Close"],button[aria-label="Close popup"]');
      if (close && close.getAttribute('aria-label') !== config.close) close.setAttribute('aria-label', config.close);
    });
    select(root, 'button[aria-label="Close teaser"]').forEach(button => {
      if (button.getAttribute('aria-label') !== config.close) button.setAttribute('aria-label', config.close);
    });
  }
  let scheduled = false;
  const pendingRoots = new Set();
  const observedContainers = [
    forms, '[id^="RecentlyViewed-"]', '[role="navigation"]', 'nav',
    '.product-section', '.jdgm-widget', '#judgeme_product_reviews',
    '.jdgm-write-review-modal__container', '.kl-teaser-WfLxww',
    '.kl-teaser-UFUqU7', 'button[aria-label="Close teaser"]'
  ].join(',');
  const observedInterfaces = observedContainers + ',[role="dialog"]';

  function enqueue(root) {
    if (!root?.isConnected) return;
    for (const pending of pendingRoots) {
      if (pending === root || pending.contains(root)) return;
      if (root.contains(pending)) pendingRoots.delete(pending);
    }
    pendingRoots.add(root);
  }

  function isRelevantInterface(root) {
    return !root.matches('[role="dialog"]') || root.matches(observedContainers) || root.querySelector(forms);
  }

  function queueInterface(root) {
    if (!root?.isConnected || !isRelevantInterface(root)) return false;
    enqueue(root);
    // A form mutation can also require a label on a close button outside the form.
    let dialog = root.closest('[role="dialog"]');
    while (dialog) {
      if (dialog.querySelector(forms)) enqueue(dialog);
      dialog = dialog.parentElement?.closest('[role="dialog"]');
    }
    return true;
  }

  function nearestInterface(node) {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    let nearest = element?.closest(observedInterfaces);
    // A review control can sit in an otherwise unrelated nested dialog.
    while (nearest && !isRelevantInterface(nearest)) nearest = nearest.parentElement?.closest(observedInterfaces);
    return nearest;
  }

  function collectAddedNode(node) {
    const nearest = nearestInterface(node);
    if (nearest && queueInterface(nearest)) return;
    if (node.nodeType === Node.ELEMENT_NODE && node.isConnected) {
      node.querySelectorAll(observedInterfaces).forEach(queueInterface);
    }
  }

  function schedule() {
    if (scheduled || !pendingRoots.size) return;
    scheduled = true;
    requestAnimationFrame(() => {
      const roots = Array.from(pendingRoots);
      pendingRoots.clear();
      try {
        roots.forEach(root => { if (root.isConnected) scan(root); });
      } finally {
        scheduled = false;
        // Keep work queued during this frame for the next frame.
        schedule();
      }
    });
  }

  const observer = new MutationObserver(records => {
    records.forEach(record => {
      const nearest = nearestInterface(record.target);
      if (nearest) queueInterface(nearest);
      record.addedNodes.forEach(collectAddedNode);
    });
    // Always collect records, including while an earlier frame is already scheduled.
    schedule();
  });
  scan();
  observer.observe(document.body, {childList:true,subtree:true,characterData:true});
})();
